import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppGuard } from '../guards/app.guard';
import { AggregatesPageComponent } from './aggregates-page/aggregates-page.component';
import { AggregatesSubnavigationComponent } from './components/aggregates-subnavigation/aggregates-subnavigation.component';

const routes: Routes = [
  {
    path: 'aggregates',
    canActivate: [AppGuard],
    children: [
      {
        path: '',
        outlet: 'subnavigation',
        component: AggregatesSubnavigationComponent,
      },
      {
        path: 'aggregates',
        component: AggregatesPageComponent,
      },
      {
        path: 'all',
        component: AggregatesPageComponent,
      },
      {
        path: '',
        redirectTo: 'all',
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AggregatesRoutingModule {}
